import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { Title } from '@angular/platform-browser';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { TipoDocumento } from 'src/app/Models/tipodocumento/tipo-documento';
import { DataService } from 'src/app/Service/data.service';
import { LoadingComponent } from '../objects/loading/loading.component';
import { NothingComponent } from '../objects/nothing/nothing.component';
import { AddSucursalComponent } from './add-sucursal/add-sucursal.component';
import { Sucursal } from 'src/app/Models/sucursal/sucursal';

@Component({
  selector: 'app-sucursal',
  templateUrl: './sucursal.component.html',
  styleUrls: ['./sucursal.component.css']
})
export class SucursalComponent implements OnInit {

  @ViewChild(LoadingComponent, null) public loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(AlertComponent, null) public alert: AlertComponent;
  @ViewChild(AddSucursalComponent, null) public frmaddsuc: AddSucursalComponent;
  public cliente: Cliente = new Cliente();
  public sucursales: Sucursal[] = [];
  public tipodocumentos: TipoDocumento[] = [];
  public orden:string;
  public pgcliente= 0;
  public filtro: Filtro = new Filtro()
  constructor(private title: Title,private data: DataService) { }

  ngOnInit() {
    this.title.setTitle('Sucursales | Sistema de ventas');
    this.GetSucursales()
  }

  GetSucursales(){
    this.data.GetSimple(this.data.api.sucursal).subscribe(
      (data)=>{
        this.sucursales = data;
      },
      (error)=>{console.log(error);
      },
    )
  }

  Searchsucursal(){
    this.data.Post('filtrardoc/Sucursal',this.filtro).subscribe(r=>{
      console.log(r);
      if (r.status==='error') {
        this.sucursales=[];
        console.log(r.message);
      }else{
        this.sucursales=r.data;
      }
    },e=>{console.log(e.error)})
  }

  OrdenarItems(){
    if (this.orden=='ASC') {
      this.sucursales.sort((a, b) => a.nombre.localeCompare(b.nombre));
    }else{
      this.sucursales.sort((a, b) => b.nombre.localeCompare(a.nombre));
    }
  }

  ShowNewTransporte(){
    if (this.sucursales.length === 7) {
      this.data.notify("Solo puede crear hasta 7 sucursales","Atención",this.data.alertType.warning)
    }else{
      this.frmaddsuc.sucursal = new Sucursal()
      this.frmaddsuc.isedit = false
      this.frmaddsuc.show(()=>{
        this.GetSucursales()
      })
    }
  }

  ShowEditTransporte(i){
    this.frmaddsuc.sucursal = i as Sucursal
    this.frmaddsuc.isedit = true
    this.frmaddsuc.show(()=>{
      this.GetSucursales()
    })
  }

  ShowDeleteTransporte(i){
    const opciones:ALertOption = new ALertOption()
    opciones.showCancelButton = true
    this.data.notify("Desea eliminar este registro?","Atencion",this.data.alertType.warning,opciones,()=>{
      this.frmaddsuc.BorrarSucursal(i as Sucursal).subscribe(
        (data)=>{this.data.notify("Elemento eliminado","Exito",this.data.alertType.success,opciones,()=>{this.GetSucursales()})},
        (error)=>{console.log(error);
        }
      )},
    ()=>{})
  }

}
